import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPageBackground} from '@Components/poster-editor/poster-editor-reducer';
import {BaseVolumeOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-volume-option/base-volume-option';
import {useAppSelector} from '@/hooks';
import {BackgroundTypeName, isVideoBackground} from '@PosterWhiteboard/page/background/background.types';

export function VideoBgVolumeOption(): ReactElement<any> | null {
  const currentPageBackground = useAppSelector(getCurrentPageBackground);

  if (!currentPageBackground) {
    return null;
  }

  if (currentPageBackground.details.type !== BackgroundTypeName.VIDEO) {
    return null;
  }

  const videoDetails = currentPageBackground.details;

  const poster = window.posterEditor?.whiteboard;
  const backgroundDetails = poster?.getCurrentPage().background.details;
  const videoBackgroundItem = backgroundDetails && isVideoBackground(backgroundDetails) ? backgroundDetails : undefined;

  if (!videoBackgroundItem?.hasAudio) {
    return null;
  }

  const updateVolume = (val: number, undoable: boolean): void => {
    const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
    if (!currentPage) {
      return;
    }
    void currentPage.background.updateFromObject(
      {
        details: {
          volume: val,
        },
      },
      {undoable}
    );
  };

  const onMuteUnmute = (): void => {
    videoBackgroundItem.toggleMuteUnmuteState();
  };

  return (
    <BaseVolumeOption
      onMuteUnmute={onMuteUnmute}
      volume={videoDetails.volume}
      onUpdateVolume={updateVolume}
    />
  );
}
